import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  TIPOS_ATENCION, TIPOS_ORIGEN_OBLIGATORIO, TIPOS_COORD_OBLIGATORIA,
  TURNOS, AREAS, TIPOS_FRENTE, ACTIVIDADES,
  calcBasura, calcML, crearActividad, listarParques,
} from "./api";

const hoy = () => new Date().toISOString().slice(0, 10);
const VACIO = {
  fecha: hoy(),
  tipo_atencion: "ORDINARIO",
  numero_crc_oficio: "",
  origen_solicitante: "",
  nombre_empleado: "",
  numero_empleado: "",
  numero_unidad: "",
  turno: "PRIMER TURNO",
  nombre_supervisor: "",
  personal_cuadrilla: 0,
  area_intervencion: "VIALIDAD",
  parque_id: "",
  intervencion_en: "",
  ubicacion: "",
  tipo_frente: "",
  metros_largo: "",
  actividades: [],
  bolsas_negras: 0,
  metros_cuadrados: "",
  metros_cubicos: "",
  litros: "",
  tipo_quimico: "",
  coordenadas_alexa_lat: "",
  coordenadas_alexa_lng: "",
  direccion_referencia: "",
  notas: "",
  lider_usuario: "",
};

export default function FormularioMesa({ user, onGuardado }) {
  const [f, setF] = useState(VACIO);
  const [parques, setParques] = useState([]);
  const [parqueQ, setParqueQ] = useState("");
  const [guardando, setGuardando] = useState(false);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const toggleAct = (a) => setF((s) => ({ ...s, actividades: s.actividades.includes(a) ? s.actividades.filter(x => x !== a) : [...s.actividades, a] }));

  // Cargar parques cuando se selecciona área = PARQUES
  useEffect(() => {
    if (f.area_intervencion === "PARQUES") {
      listarParques(parqueQ).then(setParques).catch(() => {});
    }
  }, [f.area_intervencion, parqueQ]);

  const basura = calcBasura(f.bolsas_negras);
  const ml = calcML(f.tipo_frente, f.metros_largo);
  const exigeOrigen = TIPOS_ORIGEN_OBLIGATORIO.has(f.tipo_atencion);
  const exigeCoord = TIPOS_COORD_OBLIGATORIA.has(f.tipo_atencion) && f.area_intervencion !== "PARQUES";

  const guardar = async () => {
    // Validaciones front mínimas; backend reaplica.
    if (!f.nombre_empleado) return toast.error("Falta nombre del empleado");
    if (f.actividades.length === 0) return toast.error("Selecciona al menos una actividad");
    if (!f.foto_inicio_pendiente && false) { /* placeholder: fotos en próxima fase */ }
    setGuardando(true);
    try {
      const payload = {
        ...f,
        metros_largo: f.metros_largo ? Number(f.metros_largo) : null,
        bolsas_negras: f.bolsas_negras ? Number(f.bolsas_negras) : 0,
        metros_cuadrados: f.metros_cuadrados ? Number(f.metros_cuadrados) : null,
        metros_cubicos: f.metros_cubicos ? Number(f.metros_cubicos) : null,
        litros: f.litros ? Number(f.litros) : null,
        coordenadas_alexa_lat: f.coordenadas_alexa_lat ? Number(f.coordenadas_alexa_lat) : null,
        coordenadas_alexa_lng: f.coordenadas_alexa_lng ? Number(f.coordenadas_alexa_lng) : null,
        personal_cuadrilla: Number(f.personal_cuadrilla) || 0,
      };
      Object.keys(payload).forEach(k => payload[k] === "" && (payload[k] = null));
      await crearActividad(payload);
      toast.success("Actividad registrada");
      setF(VACIO);
      onGuardado && onGuardado();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error al guardar");
    } finally { setGuardando(false); }
  };

  return (
    <div className="via-card" data-testid="form-mesa-captura">
      <h2><i className="fa-solid fa-pen-to-square"/> Capturar actividad</h2>

      <div className="via-form-grid">
        <div className="via-form-row"><label>Fecha</label><input type="date" value={f.fecha} onChange={(e) => set("fecha", e.target.value)} data-testid="mesa-fecha"/></div>
        <div className="via-form-row"><label>Tipo de atención</label>
          <select value={f.tipo_atencion} onChange={(e) => set("tipo_atencion", e.target.value)} data-testid="mesa-tipo-atencion">
            {TIPOS_ATENCION.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
      </div>

      {(f.tipo_atencion === "CRC" || f.tipo_atencion === "OFICIO") && (
        <div className="via-form-row">
          <label>{f.tipo_atencion === "CRC" ? "Número CRC" : "Nombre del Oficio"}</label>
          <input value={f.numero_crc_oficio} onChange={(e) => set("numero_crc_oficio", e.target.value)} data-testid="mesa-crc-oficio"/>
          <span className="hint">Tip: si tienes Excel, usa la importación masiva de CRC.</span>
        </div>
      )}

      {exigeOrigen && (
        <div className="via-form-row">
          <label>Nombre del solicitante (obligatorio para {f.tipo_atencion})</label>
          <input value={f.origen_solicitante} onChange={(e) => set("origen_solicitante", e.target.value)} data-testid="mesa-origen"/>
        </div>
      )}

      <div className="via-form-grid">
        <div className="via-form-row"><label>Nombre del empleado</label><input value={f.nombre_empleado} onChange={(e) => set("nombre_empleado", e.target.value)} data-testid="mesa-empleado"/></div>
        <div className="via-form-row"><label>Número de empleado</label><input value={f.numero_empleado} onChange={(e) => set("numero_empleado", e.target.value)}/></div>
        <div className="via-form-row"><label>Número de unidad</label><input value={f.numero_unidad} onChange={(e) => set("numero_unidad", e.target.value)}/></div>
        <div className="via-form-row"><label>Turno</label>
          <select value={f.turno} onChange={(e) => set("turno", e.target.value)}>
            {TURNOS.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div className="via-form-row"><label>Personal de cuadrilla</label><input type="number" min="0" value={f.personal_cuadrilla} onChange={(e) => set("personal_cuadrilla", e.target.value)}/></div>
        <div className="via-form-row"><label>Nombre del supervisor</label><input value={f.nombre_supervisor} onChange={(e) => set("nombre_supervisor", e.target.value)}/></div>
      </div>

      <div className="via-form-row">
        <label>Área de intervención</label>
        <select value={f.area_intervencion} onChange={(e) => set("area_intervencion", e.target.value)} data-testid="mesa-area">
          {AREAS.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>

      {f.area_intervencion === "PARQUES" && (
        <div className="via-card" style={{ background: "#F8FAFC" }}>
          <label style={{ fontSize: 12, fontWeight: 700 }}>Buscar parque (catálogo de Pipas, solo lectura)</label>
          <input value={parqueQ} onChange={(e) => setParqueQ(e.target.value)} placeholder="Nombre del parque…" style={{ width: "100%", padding: 8, marginTop: 4, borderRadius: 8, border: "1px solid #CBD5E1" }}/>
          <select value={f.parque_id} onChange={(e) => {
            set("parque_id", e.target.value);
            const p = parques.find(x => x.id === e.target.value);
            if (p) {
              set("intervencion_en", p.nombre);
              if (p.lat && p.lng) {
                set("coordenadas_alexa_lat", p.lat);
                set("coordenadas_alexa_lng", p.lng);
              }
            }
          }} size={Math.min(8, Math.max(3, parques.length))} style={{ width: "100%", marginTop: 6 }} data-testid="mesa-parque-id">
            <option value="">— elige un parque —</option>
            {parques.map(p => <option key={p.id} value={p.id}>{p.nombre} {p.zona ? `· ${p.zona}` : ""}</option>)}
          </select>
        </div>
      )}

      {f.area_intervencion === "VIALIDAD" && (
        <div className="via-form-grid">
          <div className="via-form-row"><label>Tipo de frente</label>
            <select value={f.tipo_frente} onChange={(e) => set("tipo_frente", e.target.value)} data-testid="mesa-tipo-frente">
              <option value="">— elige —</option>
              {TIPOS_FRENTE.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div className="via-form-row">
            <label>Metros de largo</label>
            <input type="number" min="0" step="0.1" value={f.metros_largo} onChange={(e) => set("metros_largo", e.target.value)} data-testid="mesa-metros-largo"/>
            <span className="hint">ML auto: {ml ?? "—"}</span>
          </div>
        </div>
      )}

      {f.area_intervencion !== "PARQUES" && f.area_intervencion !== "VIALIDAD" && (
        <div className="via-form-row">
          <label>Nombre del lugar</label>
          <input value={f.intervencion_en} onChange={(e) => set("intervencion_en", e.target.value)}/>
          <span className="hint">Este lugar llega por Oficio, CRC o solicitud del Director.</span>
        </div>
      )}

      {(exigeCoord || f.area_intervencion !== "PARQUES") && (
        <div className="via-form-grid">
          <div className="via-form-row">
            <label>Coordenadas — latitud{exigeCoord ? " *" : ""}</label>
            <input type="number" step="0.000001" value={f.coordenadas_alexa_lat} onChange={(e) => set("coordenadas_alexa_lat", e.target.value)} placeholder="28.6789" data-testid="mesa-lat"/>
          </div>
          <div className="via-form-row">
            <label>Coordenadas — longitud{exigeCoord ? " *" : ""}</label>
            <input type="number" step="0.000001" value={f.coordenadas_alexa_lng} onChange={(e) => set("coordenadas_alexa_lng", e.target.value)} placeholder="-106.0876" data-testid="mesa-lng"/>
          </div>
        </div>
      )}
      <div className="via-form-row">
        <label>Dirección de referencia</label>
        <input value={f.direccion_referencia} onChange={(e) => set("direccion_referencia", e.target.value)}/>
      </div>

      <div className="via-card" style={{ background: "#F8FAFC" }}>
        <strong style={{ fontSize: 13 }}>Actividades</strong>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginTop: 6 }}>
          {ACTIVIDADES.map(a => (
            <label key={a} style={{ fontSize: 12, fontWeight: 600 }} data-testid={`mesa-act-${a.replace(/ /g, "_")}`}>
              <input type="checkbox" checked={f.actividades.includes(a)} onChange={() => toggleAct(a)}/> {a}
            </label>
          ))}
        </div>

        <div className="via-form-grid" style={{ marginTop: 10 }}>
          <div className="via-form-row">
            <label>Bolsas negras</label>
            <input type="number" min="0" value={f.bolsas_negras} onChange={(e) => set("bolsas_negras", e.target.value)} data-testid="mesa-bolsas"/>
            <span className="hint">≈ {basura.kg} kg · {basura.toneladas} ton</span>
          </div>
          <div className="via-form-row"><label>m² (área)</label><input type="number" min="0" value={f.metros_cuadrados} onChange={(e) => set("metros_cuadrados", e.target.value)}/></div>
          <div className="via-form-row"><label>m³ (volumen)</label><input type="number" min="0" value={f.metros_cubicos} onChange={(e) => set("metros_cubicos", e.target.value)}/></div>
          <div className="via-form-row"><label>Litros</label><input type="number" min="0" value={f.litros} onChange={(e) => set("litros", e.target.value)}/></div>
          {f.actividades.includes("APLICACIÓN DE QUÍMICOS") && (
            <div className="via-form-row" style={{ gridColumn: "1 / -1" }}>
              <label>Tipo de químico</label>
              <input value={f.tipo_quimico} onChange={(e) => set("tipo_quimico", e.target.value)}/>
            </div>
          )}
        </div>
      </div>

      <div className="via-form-row">
        <label>Notas</label>
        <textarea rows={2} value={f.notas} onChange={(e) => set("notas", e.target.value)}/>
      </div>

      <div className="via-form-row" style={{ background: "#FEF3C7", padding: 8, borderRadius: 8 }}>
        <span style={{ fontSize: 12, color: "#92400E" }}>
          <i className="fa-solid fa-circle-info"/>{" "}
          Fotos (Inicio · Proceso · Final): el líder de cuadrilla las sube desde el celular.
          La captura aquí queda en estatus PENDIENTE hasta que se complete la evidencia en campo.
        </span>
      </div>

      <button className="via-btn" disabled={guardando} onClick={guardar} data-testid="mesa-guardar" style={{ marginTop: 8 }}>
        {guardando ? "Guardando…" : "Guardar actividad"}
      </button>
    </div>
  );
}
